import { groupMatch } from './group-match.validator';

// @dynamic
export class FvehValidators {
  static groupMatch = groupMatch;
}
